import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './sensor.reducer';
import { ISensor } from 'app/shared/model/sensor.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SensorUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const sensorEntity = useAppSelector(state => state.sensor.entity);
  const loading = useAppSelector(state => state.sensor.loading);
  const updating = useAppSelector(state => state.sensor.updating);
  const updateSuccess = useAppSelector(state => state.sensor.updateSuccess);

  const handleClose = () => {
    props.history.push('/sensor' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...sensorEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          sensorConsolidatedMethod: 'NONE',
          ...sensorEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.sensor.home.createOrEditLabel" data-cy="SensorCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.sensor.home.createOrEditLabel">Create or edit a Sensor</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="sensor-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  className="d-none"
                />
              ) : null}
              <ValidatedField 
                label={translate('fleetSenseApp.sensor.name')} 
                id="sensor-name" 
                name="name" 
                required
                data-cy="name" 
                type="text" />
              <ValidatedField
                label={translate('fleetSenseApp.sensor.description')}
                id="sensor-description"
                name="description"
                required
                data-cy="description"
                type="text"
              />
              <ValidatedField 
                label={translate('fleetSenseApp.sensor.unit')} 
                id="sensor-unit" 
                name="unit"
                required 
                data-cy="unit" 
                type="text" />
              <ValidatedField
                label={translate('fleetSenseApp.sensor.sensorConsolidatedMethod')}
                id="sensor-sensorConsolidatedMethod"
                name="sensorConsolidatedMethod"
                required
                data-cy="sensorConsolidatedMethod"
                type="select"
              >
                <option value="NONE">{translate('fleetSenseApp.SensorConsolidatedMethod.NONE')}</option>
                <option value="AVG">{translate('fleetSenseApp.SensorConsolidatedMethod.AVG')}</option>
                <option value="LAST">{translate('fleetSenseApp.SensorConsolidatedMethod.LAST')}</option>
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/sensor" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SensorUpdate;
